const initialState = {
  /** { [productId]: { QUESTIONS: [], REVIEWS: [] } } */
  data: {},
};

export const reviewsAndQuestionsReducer = (state = initialState, action) => {
  switch (action.type) {
    case "FETCH_REVIEWS_AND_QUESTIONS_BY_IDS":
      return { ...state, data: action.payload || {} };
    default:
      return state;
  }
};
